/* eslint-disable */
const protobufPackageSarasa = "decentraland.sdk.components.common";
/**
 * @public
 */
export var TextAlignMode;
(function (TextAlignMode) {
    TextAlignMode[TextAlignMode["TAM_TOP_LEFT"] = 0] = "TAM_TOP_LEFT";
    TextAlignMode[TextAlignMode["TAM_TOP_CENTER"] = 1] = "TAM_TOP_CENTER";
    TextAlignMode[TextAlignMode["TAM_TOP_RIGHT"] = 2] = "TAM_TOP_RIGHT";
    TextAlignMode[TextAlignMode["TAM_MIDDLE_LEFT"] = 3] = "TAM_MIDDLE_LEFT";
    TextAlignMode[TextAlignMode["TAM_MIDDLE_CENTER"] = 4] = "TAM_MIDDLE_CENTER";
    TextAlignMode[TextAlignMode["TAM_MIDDLE_RIGHT"] = 5] = "TAM_MIDDLE_RIGHT";
    TextAlignMode[TextAlignMode["TAM_BOTTOM_LEFT"] = 6] = "TAM_BOTTOM_LEFT";
    TextAlignMode[TextAlignMode["TAM_BOTTOM_CENTER"] = 7] = "TAM_BOTTOM_CENTER";
    TextAlignMode[TextAlignMode["TAM_BOTTOM_RIGHT"] = 8] = "TAM_BOTTOM_RIGHT";
})(TextAlignMode || (TextAlignMode = {}));
/**
 * @public
 */
export var Font;
(function (Font) {
    Font[Font["F_SANS_SERIF"] = 0] = "F_SANS_SERIF";
    Font[Font["F_SERIF"] = 1] = "F_SERIF";
    Font[Font["F_MONOSPACE"] = 2] = "F_MONOSPACE";
})(Font || (Font = {}));
